import * as Yup from "yup";
import dayjs from "dayjs";

export const validateRowSchema = Yup.object().shape({
    id: Yup
        .string()
        .required("Required"),
    // description: Yup
    //     .string()
    //     .required("Required"),
})

export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required("Required"),
    documentDate: Yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    rows: Yup.array().of(validateRowSchema)
})


export const validationUpdateSchema = Yup.object({
    driverUserId: Yup
        .string()
        .required("Required"),
    logisticId: Yup
        .string()
        .required("Required"),
})

export const initialRowValues = {
    id: "",
    documentDocId: 0,
    name: "",
    description: ""
}

export const initialValues = {
    locationId: "",
    locationName: "",
    documentNumber: "",
    documentDate: dayjs(),
    remark: "",
    referenceNo: "",
    rows: [initialRowValues]
}